<template>
  <div class="min-h-screen">
    <header>
      <nav>
        <Navbar />
      </nav>
    </header>
    <main class="mt-12 min-h-[calc(100vh-3rem)]">
      <slot />
    </main>
  </div>
</template>

<script>
import Navbar from '~/components/layouts/Navbar.vue';

export default {
  components: {
    Navbar
  }
};
</script>

<style  scoped></style>
